<ng-container *transloco="let t">
    <h2>{{ t('favourites.latest-title') }}</h2>
    <td-favourites-table [first]="5" (loaded)="this.loaded.next($event)" (initialLoading)="this.initialLoading.next($event)"></td-favourites-table>
    <div class="mt-3">
        <a [routerLink]="['/address', address, 'favourites']">{{ t('general.see-more') }}</a>
    </div>
</ng-container>
